module.exports = __webpack_public_path__ + "static/try-06b80880a0536c38a13aaf877822ef1a.mp4";